// extracted by mini-css-extract-plugin
module.exports = {"label":"add_label_27CM2","err":"add_err_3rhbY"};